angular.module('impactx.panel').controller('TenderPreviewPanelCtrl', [
    '$scope',
    'TranslationService',
    'panelService',
    'ImageEditor',
    TenderPreviewPanelCtrl]);

function TenderPreviewPanelCtrl($scope, TranslationService, panelService, ImageEditor) {
    var self = this;
    self.getTenderPanelColor = panelService.getTenderPanelColor;
    if(!$scope.trns) {
        $scope.trns = {};
    }
    $scope.trns.tender = TranslationService.get('tender');

    $scope.getLabel = function() {
        return self.treatmentType ? self.treatmentType : TranslationService.get('tender');
    };


    self.deleteImage = function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = "img/missing-image.jpg";
    };

    self.openEditor = function (event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'square').then(function (croppedImage) {
            if(!croppedImage) {
                return
            } else if(!croppedImage.image) {
                self.deleteImage(event)
            } else {
                self.image.file = croppedImage.image;
                self.image.fileName = croppedImage.name;
                self.image.isDeleted = true;
            }
        })
    };

    $scope.$watch(function () {
        return impactX.isDefined(self, "image.file");
    }, function (newValue, oldValue) {
        if (newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}